module.exports = __webpack_public_path__ + "img/marker_set.62f90713.svg";